<template>
<zj-layout-container>
  <zj-layout-main>
    <div class="zj-layout-main-content bgcolor scrollable" ref="container">
      上报数据
    </div>
  </zj-layout-main>
</zj-layout-container>
</template>

<script>
export default {
  name: 'ZjTourReportHome',
  controller: 'UI',
  action: 'Home'
}
</script>
